import {useMediaQuery} from '@mui/material'
import {FC} from 'react'
import {FeatureBlock} from 'entities/credits'
import {PackageType} from 'entities/payment'
import {getDiscount, getPerCoinValue} from 'shared/lib'
import {HorizontalDivider} from 'shared/ui/dividers'
import styles from './styles.module.scss'

const DEFAULT_FEATURE_COUNT = 1

type CurrentPackageProps = {
  openPackage: PackageType
  withSale: boolean
  isVisible: boolean
}

export const CurrentPackage: FC<CurrentPackageProps> = ({openPackage, withSale, isVisible}) => {
  const is768p = useMediaQuery(`(max-width: ${styles.is768p})`)
  
  if (!isVisible) return <></>

  return (
    <div className={styles.package}>
      <div className={styles.package__header}>
        <div className={styles.package__title}>
          <h5 className={styles.title}>{openPackage?.name || ''}</h5>
          {openPackage ? (
            <span className={styles.perCoin}>
              ~ ${getPerCoinValue(openPackage.price, openPackage.credits)} per
              coin
            </span>
          ) : null}
        </div>
        {withSale ? (
          <span className={styles.discount}>
            -{getDiscount(openPackage.price, openPackage.originPrice)}% off
          </span>
        ) : null}
      </div>
      {openPackage ? (
        <FeatureBlock
          credits={openPackage.credits}
          stickers={openPackage.stickers}
          photos={openPackage.photos}
          videos={openPackage.videos}
          virtualGifts={openPackage.virtualGifts}
          displayItemsCount={is768p ? DEFAULT_FEATURE_COUNT : undefined}
        />
      ) : null}
      <HorizontalDivider />

      <div className={styles.totalContainer}>
        <span className={styles.text}>Total (USD)</span>
        <div className={styles.prices}>
          <b className={styles.total}>${openPackage?.price}</b>
          {withSale ? (
            <span className={styles.sale}>${openPackage.originPrice}</span>
          ) : null}
        </div>
      </div>
    </div>
  )
}
